import React from "react";
import PageWrapper from "components/PageWrapper";
import { END_POINT } from "constants/apiConstant";
import TableComponent from "components/TableComponent";
import { formatDate } from "utils/helper";

const statusPill = (status) =>
  status == "2"
    ? { label: "Completed", pill: "bg-s360-success-bg text-s360-success-ink", dot: "bg-s360-success" }
    : { label: "Pending", pill: "bg-s360-danger-bg text-[#700A14]", dot: "bg-s360-danger" };

const HistoryPage = () => {
  const columnHeaders = [
    {
      dataField: "part_number",
      name: "Part Number",
      headerAlign: "left",
      style: { textAlign: "left" },
      formatter: (col, row) => (
        <span className="font-mono text-[13px] font-semibold text-s360-violet">
          {row?.part_number}
        </span>
      ),
    },
    {
      dataField: "created_at",
      name: "Created At",
      headerAlign: "left",
      style: { textAlign: "left" },
      formatter: (col, row) => formatDate(row.created_at),
    },
    {
      dataField: "status",
      name: "Status",
      headerAlign: "center",
      style: { textAlign: "center" },
      formatter: (col, row) => {
        const meta = statusPill(row?.status);
        return (
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded text-xs font-semibold ${meta.pill}`}
          >
            <span className={`w-1.5 h-1.5 rounded-full ${meta.dot}`} />
            {meta.label}
          </span>
        );
      },
    },
  ];

  return (
    <PageWrapper showHeader={false}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1.5">
          <h1 className="text-[28px] leading-[34px] font-bold tracking-[-0.015em] text-s360-ink">
            Search history
          </h1>
          <span className="text-sm text-s360-fg3">
            Your recent part searches and their processing status.
          </span>
        </div>

        <div className="bg-white rounded-md shadow-sm overflow-hidden border-t-[3px] border-t-s360-violet">
          <TableComponent
            apiRoute={END_POINT.GET_SEARCH_HISTORY_API}
            columnHeaders={columnHeaders}
            searchPlaceholder="Search by part number…"
            noBorderRadius
          />
        </div>
      </div>
    </PageWrapper>
  );
};

export default HistoryPage;
